module.exports = __webpack_public_path__ + "media/photography/galleryImage9New-cb533fe7.jpg";